import { Label } from "@/shared/ui/label";

/**
 * Sheet/Form 内的视觉分段。同一 Sheet 里把"基础 / 连接 / 人设"用 small caps 标题
 * 分开,标题下方有底边线,提供清晰的层次而不至于像 Tabs 那么重。
 */
export function Section({
  title,
  hint,
  icon,
  right,
  children,
}: {
  title: string;
  hint?: string;
  icon?: React.ReactNode;
  right?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-3">
      <div className="flex items-end justify-between border-b pb-1.5">
        <div className="flex items-center gap-1.5">
          {icon && <span className="text-muted-foreground/60">{icon}</span>}
          <span className="text-2xs font-semibold uppercase tracking-wider text-muted-foreground/80">
            {title}
          </span>
          {hint && <span className="text-2xs text-muted-foreground/60">· {hint}</span>}
        </div>
        {right}
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

/** Form field 包装:label(可选 *) + control + 选填的 hint(描述文字)。 */
export function Field({
  label,
  required,
  hint,
  children,
}: {
  label: string;
  required?: boolean;
  hint?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs">
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      {children}
      {hint && <p className="text-2xs text-muted-foreground/80 leading-relaxed">{hint}</p>}
    </div>
  );
}
